// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__1km2a","div":"ProgressBar_div__2anrI","belt":"ProgressBar_belt__3lcds","p":"ProgressBar_p__35MZD"};